<template>
  <div class="active-user">
    <div class="active-user__close-cross" v-if="showCloseCross" @click="$emit('close')">
      <span class="icon-cross2"></span>
    </div>
    <h2 class="marg-10-bottom">{{ allUsersInHash[activeUserId].name }}</h2>
    <TasksTable :title="i18n[locale]['subjects']"
                hoursTitle="UV"
                id="teaching"
                :tasks="getAllUserSubjectsAndTeachingTasks"
                :user="allUsersInHash[activeUserId]"
                :userCalendarId="userCalId"
                @edit="setEditTask"
                @setActiveSubject="setActiveSubject"
                :assignedHours="getUserAssignedTeachingHours(activeUserId)"
                :isTeaching="true"
                :isPoolsDeactivated="isPoolsDeactivated">
    </TasksTable>

    <TasksTable :title="i18n[locale]['additional_tasks']"
                id="tasks"
                hoursTitle="Øvrig"
                :user="allUsersInHash[activeUserId]"
                :tasks="getAllUserTasksTask"
                :userCalendarId="userCalId"
                @edit="setEditTask"
                :assignedHours="getUserAssignedTaskHours(activeUserId)"
                :isPoolsDeactivated="isPoolsDeactivated">
    </TasksTable>
    <TasksTable :title="i18n[locale]['preparation']"
                id="preperation"
                hoursTitle="Forb."
                :user="allUsersInHash[activeUserId]"
                :tasks="getAllUserTasksPrep"
                :userCalendarId="userCalId"
                @edit="setEditTask"
                :assignedHours="getUserAssignedPreparationHours(activeUserId)"
                :isPoolsDeactivated="isPoolsDeactivated">
    </TasksTable>
    <TasksTable
      v-if="getAllUserTasksClub.length > 0"
      :title="i18n[locale]['club']"
      id="club"
      hoursTitle="SFO."
      :user="allUsersInHash[activeUserId]"
      :tasks="getAllUserTasksClub"
      :userCalendarId="userCalId"
      @edit="setEditTask"
      :assignedHours="getUserAssignedClubHours(activeUserId)"
      :isPoolsDeactivated="isPoolsDeactivated">
    </TasksTable>
    <div class="active-user__agreements">
      <SubjectsDistributionUserAgreements :userId="activeUserId"></SubjectsDistributionUserAgreements>
    </div>
    <transition name="d-modal">
      <DModal v-if="theActiveSubject" :showClose="false" @close="theActiveSubject = null" style="border-radius: 4px">
        <SubjectsDistributionUserEditHours
          slot="insertComponent"
          :subject="getTheActiveSubject"
          :teacher="getTheActiveUser"
          @close="theActiveSubject = null"/>
      </DModal>
    </transition>
    <div class="bg-overlay"
         v-if="theActiveSubject"
         @click="theActiveSubject = null">
    </div>
  </div>
</template>

<script>
import SubjectsDistributionUserAgreements from './SubjectsDistributionUserAgreements'
import SubjectsDistributionUserEditHours from './SubjectsDistributionUserEditHours'
import TasksTable from './SubjectsDistributionUserTable'
import DDropdown from '../common/DDropdown'
import DModal from '../common/DModal'

const I18N = {
  da: {
    subjects_for_teachers: 'Fagfordeling',
    filter_users: ' Filtrer på teams',
    teaching_hours_from_subjects: 'UV-TID FRA FAG',
    created_subject: 'Oprettede faget',
    klass: 'Tilhører',
    subjects: 'Undervisning',
    teaching_hours: 'UV tid',
    no_subjects_assigned: 'Ingen fag tildelt',
    assigned: 'Tildelt',
    from_subjects: 'Fra fag',
    difference: 'Diff',
    only_subjects_without_teachers: 'Vis kun fag uden underviser',
    hours_in_school_year: 'Timer i skoleåret',
    time: 'Timer',
    additional_tasks: 'Øvrige opgaver',
    preparation: 'Forberedelse',
    club: 'SFO'
  },
  en: {
    subjects_for_teachers: 'Teacher-subject allocation',
    filter_users: ' Filter users by groups',
    teaching_hours_from_subjects: 'Annual instruction time from subjects',
    created_subject: 'Created subject',
    klass: 'Class',
    subjects: 'Subjects',
    teaching_hours: 'Instruction time',
    no_subjects_assigned: 'No subjects allocated',
    assigned: 'Allocated',
    from_subjects: 'From subjects',
    difference: 'Diff',
    only_subjects_without_teachers: 'Show only subjects without teachers',
    hours_in_school_year: 'Annual Instruction Time',
    time: 'Hours',
    additional_tasks: 'Not teaching',
    preparation: 'Preparation',
    club: 'club'
  },
  nb: {
    subjects_for_teachers: 'Fag- og lærerfordeling',
    filter_users: ' Filtrer etter gruppe',
    teaching_hours_from_subjects: 'Årstimetall',
    created_subject: 'Opprettet faget',
    klass: 'Klasse',
    subjects: 'Fag',
    teaching_hours: 'Timetall',
    no_subjects_assigned: 'Ingen fag tildelt',
    assigned: 'Tildelt',
    from_subjects: 'Fra fag',
    difference: 'Diff',
    only_subjects_without_teachers: 'Vis kun fag uten underviser',
    hours_in_school_year: 'Timer i skoleåret',
    time: 'Timer',
    additional_tasks: 'Øvrige oppgaver',
    preparation: 'Forberedelse',
    club: 'SFO'
  }
}

export default {
  components: {SubjectsDistributionUserAgreements, DDropdown, DModal, SubjectsDistributionUserEditHours, TasksTable},
  props: {
    activeUserId: {
      default: null
    },
    showCloseCross: {
      default: true
    },
    isPoolsDeactivated: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      locale: 'da',
      isPrint: false,
      theActiveSubject: null,
      userTasksTasks: []
    }
  },
  computed: {
    i18n () {
      return I18N
    },
    getTheActiveSubject () {
      return this.theActiveSubject ? this.subjectsInHash[this.theActiveSubject] : null
    },
    getTheActiveUser () {
      return this.activeUserId ? this.allUsersInHash[this.activeUserId] : null
    },
    isTestSchool () {
      return window.SCHOOL.country === 'DK'
    },
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    subjectsInUserHash () {
      return this.$store.getters.subjectsInUserHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    },
    usersAssignedHoursHash () {
      return this.$store.getters.usersAssignedHoursHash
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    tasksInUserHash () {
      return this.$store.getters.tasksInUserHash
    },
    tasksInHash () {
      return this.$store.getters.tasksInHash
    },
    userCalId () {
      return this.allUsersInHash[this.activeUserId].user_calendar_id
    },
    allUserTasks () {
      return this.tasksInUserHash[this.userCalId] ? this.tasksInUserHash[this.userCalId].map(taskId => this.tasksInHash[taskId]) : []
    },
    getAllUserTasksTask () {
      return this.allUserTasks.filter(task => task.subject_type === 'additional_tasks')
    },
    getAllUserTasksPrep () {
      return this.allUserTasks.filter(task => task.subject_type === 'preparation')
    },
    getAllUserTasksClub () {
      return this.allUserTasks.filter(task => task.subject_type === 'club')
    },
    getAllUserTasksTeaching () {
      return this.allUserTasks.filter(task => task.subject_type === 'person_resource' || task.subject_type === 'person_resource_visible' || task.subject_type === 'subject')
    },
    getAllUserSubjectsAndTeachingTasks () {
      let calId = this.userCalId
      let subjects = this.subjectsInUserHash[calId] ? this.subjectsInUserHash[calId].map(subjectId => this.subjectsInHash[subjectId]) : []
      subjects = subjects.filter(subject => {
        if (this.allCalendarsInHash[subject.calendar_id]) {
          const calendarType = this.allCalendarsInHash[subject.calendar_id].type
          return calendarType === 'klass' || calendarType === 'merge'
        } else {
          console.log('error::calendar not found', subject.calendar_id)
        }
      })
      return subjects.concat(this.getAllUserTasksTeaching)
    }
  },
  methods: {
    getUserAssignedTotalHours (userId) {
      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_total_hours ? this.usersAssignedHoursHash[userId].assigned_total_hours : 0
    },
    getPercentageOfTeaching (userId) {
      let total = this.getUserAssignedTotalHours(userId)
      let teaching = this.getUserAssignedTeachingHours(userId)
      let percentage = (teaching / total * 100)
      return percentage.toFixed(0) + '%'
    },
    getUserAssignedTaskHours (userId) {
      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_additional_task_hours ? this.usersAssignedHoursHash[userId].assigned_additional_task_hours : 0
    },
    getPercentageOfTasks (userId) {
      let total = this.getUserAssignedTotalHours(userId)
      let tasks = this.getUserAssignedTaskHours(userId)
      let percentage = (tasks / total * 100)
      return percentage.toFixed(0) + '%'
    },
    getUserAssignedPreparationHours (userId) {
      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_preparation_hours ? this.usersAssignedHoursHash[userId].assigned_preparation_hours : 0
    },
    getUserAssignedClubHours (userId) {
      return this.usersAssignedHoursHash[userId] && this.usersAssignedHoursHash[userId].assigned_club_hours ? this.usersAssignedHoursHash[userId].assigned_club_hours : 0
    },
    getPercentageOfPrep (userId) {
      let total = this.getUserAssignedTotalHours(userId)
      let tasks = this.getUserAssignedPreparationHours(userId)
      let percentage = (tasks / total * 100)
      return percentage.toFixed(0) + '%'
    },
    getAllUserSubjects (calid) {
      let subjects = this.subjectsInUserHash[calid] ? this.subjectsInUserHash[calid] : []
      return subjects.sort((subjectA, subjectB) => {
        let subjectFromSubjectA = this.allCalendarsInHash[this.subjectsInHash[subjectB].calendar_id]
        let subjectFromSubjectB = this.allCalendarsInHash[this.subjectsInHash[subjectA].calendar_id]
        if ((subjectFromSubjectA && subjectFromSubjectA.name) && (subjectFromSubjectB && subjectFromSubjectB.name)) {
          return subjectFromSubjectA.name.localeCompare(subjectFromSubjectB.name, undefined, {
            numeric: true,
            sensitivity: 'base'
          })
        }
      })
    },
    setEditSubject (editSubject) {
      this.$emit('editSubject', editSubject)
    },
    setEditTask (editTask) {
      // A task can be a subject
      if (editTask.hasOwnProperty('can_schedule')) {
        this.$emit('editTask', editTask)
      } else {
        this.$emit('editSubject', editTask)
      }
    },
    setDeleteTask (taskId) {
      let task = this.tasksInHash[taskId]
      task['itemType'] = 'task'
      this.$store.commit('setItemToDelete', task)
      this.$store.commit('setConfirmDeletion', true)
    },
    getUserAssignedTeachingHours (userId) {
      return this.usersAssignedHoursHash[userId] ? this.usersAssignedHoursHash[userId].assigned_teaching_hours : 0
    },
    getTotalSubjectTeachingHours (userCalId) {
      let subjectsHours = this.subjectsInUserHash[userCalId] ? this.subjectsInUserHash[userCalId].map(subjectId => this.getSubjectHours(subjectId) * 1) : [0]
      let sum = subjectsHours.reduce((acc, item) => acc + item)
      return sum.toFixed(2)
    },
    getTotalUserTasksTeachingHours (userCalId) {
      let tasksHours = this.tasksInUserHash[userCalId] ? this.tasksInUserHash[userCalId].map(taskId => this.tasksInHash[taskId].timeTeaching * 1) : [0]
      return tasksHours.reduce((acc, item) => acc + item).toFixed(2)
    },
    getTotalUserHoursTeachingCount (userCalId) {
      let sum = (this.getTotalSubjectTeachingHours(userCalId) * 1) + (this.getTotalUserTasksTeachingHours(userCalId) * 1)
      return sum.toFixed(2)
    },
    getUserTeachingHoursDiff (userId) {
      let diff = this.getUserAssignedTeachingHours(userId) - this.getTotalUserHoursTeachingCount(this.allUsersInHash[userId].user_calendar_id)
      return diff.toFixed(1)
    },
    getTotalUserTasksHours (userCalId) {
      let tasksHours = this.tasksInUserHash[userCalId] ? this.tasksInUserHash[userCalId].map(taskId => this.tasksInHash[taskId].hours * 1) : [0]
      let sum = tasksHours.reduce((acc, item) => acc + item)
      return sum.toFixed(1)
    },
    setActiveSubject (subject) {
      this.theActiveSubject = subject
    },
    getSubjectHours (subjectId) {
      let theSubject = this.subjectsInHash[subjectId]
      let idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(teacher => teacher.user_id === this.activeUserId) : -1
      if (idx > -1) {
        return theSubject.teachers[idx].hours
      } else {
        return theSubject.hours
      }
    },
    getIsHoursModified (subjectId) {
      let theSubject = this.subjectsInHash[subjectId]
      let idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(teacher => teacher.user_id === this.activeUserId) : -1
      return idx > -1
    }
  },
  beforeMount () {
    this.locale = window.USER.language
  }
}
</script>


<style scoped>

.active-user {
  position: relative;
  width: 100%;
  margin-bottom: 20px;
}

.active-user h2 {
  margin-right: 20px;
}

.active-user__close-cross {
  position: absolute;
  z-index: 100;
  top: 0;
  right: 0;
  border-radius: 50%;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.15s;
}

.active-user__close-cross:hover {
  background: #eee;
}

.d-table, .subjects-and-tasks {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th, .d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 2px 4px;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 4px;
}

.subjects_subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 2.5px 5px 2.5px 0px;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
  cursor: pointer;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.is-number {
  text-align: right;
}

tbody tr:first-child td .subjects_subject {
  margin-top: 5px;
}

tbody tr:last-child td .subjects_subject {
  margin-bottom: 10px;
}

.active-user__agreements {
  margin-top: 10px;
}

.subject-hours-for-person {
  position: relative;
  cursor: pointer;
  transition: transform 0.25s;
}

.subject-hours-for-person:hover {
  transform: translateY(-1px);
  text-decoration: underline;
  color: #468AD7;
}

.subject-hours-for-person.subject-hours-for-person--is-modified:after {
  content: "\e904";
  position: absolute;
  bottom: 10px;
  padding: 4px;
  left: 0px;
  font-family: 'icomoon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  -webkit-font-feature-settings: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// SubjectsDistributionUser.vue?3ccb8ab9